var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
import { ENDPOINTS, OBJECTIVES_TABLES, OBJECTIVES_TABLES_LIST } from "./config";
function addKeyToFields(fields, prefix) {
    if (!fields)
        return [];
    return Object.entries(fields).map(([key, field]) => {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        // Add default align based on field type
        const align = field.type === 'string' ? 'left' : 'right';
        return Object.assign({ key: fullKey, align }, field);
    });
}
export function fetchObjectiveFields() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield HttpClient.get(ENDPOINTS.FETCH_OBJECTIVE_FIELDS);
        // Ocultar las columnas de crecimiento de Castilla solo en Objectives Report (sin tocar backend)
        const VOLUMEN_CASTILLA = OBJECTIVES_TABLES.COLUMNAS_SELECCIONADAS_CENTER_VOLUMEN_CASTILLA;
        if (response.data[VOLUMEN_CASTILLA]) {
            // Eliminamos del diccionario de campos para que no aparezcan en tabla, filtros ni exportaciones.
            // Nota: Esto no afecta a cálculos, ya que las fórmulas usan propuesta_bp_{mes_natural}.
            delete response.data[VOLUMEN_CASTILLA]["crecimiento_aant"];
            delete response.data[VOLUMEN_CASTILLA]["crec_acum"];
        }
        const data = [
            ...addKeyToFields(response.data[OBJECTIVES_TABLES.COLUMNAS_SELECCIONADAS]),
            ...OBJECTIVES_TABLES_LIST.flatMap((tableKey) => addKeyToFields(response.data[tableKey], tableKey)),
        ];
        return data;
    });
}
